import { webDtos, webEnums } from '@vectronic/openApi-customer';
import { FilterItemWithLabel, FixTypeMode } from '@vectronic/util';

export enum FilterTitles {
  PROJECT = 'Project',
  ORIGIN = 'Origin',
  SPECIES = 'Species',
  SEX = 'Sex',
  COORDINATES = 'Coordinates',
  VF_STATUS = 'VF Status',
  MORTALITY_STATUS = 'Mortality Status',
  MORTALITY_TYPE = 'Mortality Type',
  ANIMAL_NAME = 'Animal Name',
  ANIMATION_PLAY = 'Animation',
  HIDE_INVALID_POSITIONS = 'Hide Invalid',
  ONLY_LOCAL = 'Local',
  SHOW_SYSTEM_LOG = 'Show System Log',
  DOWNLOAD_TS = 'Download Time',
  FIX_TYPE = 'Fix Type',
  EVENT = 'Event',
  UTC = 'Acq. Time',
  SCTS = 'SCTS',
  LAST_X_RECORDS = 'Last X Records',
  DEPLOYED_ONLY = 'Deployed Only',
  COMMAND_STATUS = 'Status',
  DEVICE_ID = 'Device ID',
  COM_TYPE = 'Com Type ',
  GROUPS = 'Groups ',
  MOTION_DATA_TYPE = 'Motion Data Type',
  DEVICE_TYPE = 'Device Type',
  NETWORK_STATUS = 'Network Status',
  COLLAR_ATTACHED = 'Collar Attached',
  LAST_RECEPTION = 'Last Reception',
}

const mortalityStatusFilterList = [
  { label: 'Not available', item: 'NOT_AVAILABLE' },
  { label: 'Alive', item: 'NOTHING_DETECTED' },
  { label: 'Dead', item: 'MORTALITY_NO_RADIUS' },
];

const comTypeFilterList = Object.values(webDtos.CollarExternalRequest.ComTypeFilterEnum).map(
  (v) => ({ item: v, label: v }),
);

const originFilterList = [
  { label: 'Terminal', item: 'TERMINAL' },
  { label: 'Iridium', item: 'IRIDIUM' },
  { label: 'GSM-FTP', item: 'GSM_FTP' },
  { label: 'GSM-SMS', item: 'GSM_SMS' },
  { label: 'Device Download', item: 'COLLAR' },
  { label: 'Globalstar', item: 'GLOBALSTAR' },
  { label: 'IoT', item: 'NB_IOT' },
];

const statusFilterList = [
  { name: 'within bounds', value: true },
  { name: 'out of bounds', value: false },
];

const sexFilterList = [
  { label: 'Male', item: 'MALE' },
  { label: 'Female', item: 'FEMALE' },
  { label: 'Unknown', item: 'UNKNOWN' },
  { label: 'Undefined', item: 'UNDEFINED' },
];

const networkStatusFilterList = [
  { label: 'Activated', item: 'ACTIVATED' },
  { label: 'Deactivated', item: 'DEACTIVATED' },
  { label: 'Change Requested', item: 'changeRequested' },
];

const collarAttachedFilterList = [
  { name: 'Yes', value: true },
  { name: 'No', value: false },
];

const mortalityTypeFilterList = [
  { name: 'Mortality', value: 'MORTALITY' },
  { name: 'Low Activity', value: 'LOW_ACTIVITY' },
  { name: 'Lateral', value: 'LATERAL' },
];

const separationTypeFilterList = [
  { name: 'No Contact', value: 'NO_CONTACT' },
  { name: 'Status', value: 'STATUS' },
  { name: 'Mortality', value: 'MORTALITY' },
];

const vaginalImplantFilterList = [
  { name: 'Mortality', value: 'NO_CONTACT' },
  { name: 'Low Activity', value: 'STATUS' },
];

const fixTypeFilterList = [
  { label: 'No Fix', item: 'NO_FIX' },
  { label: '1 GPS Sat', item: 'ONE_GPS_SAT' },
  { label: '2 GPS Sat', item: 'TWO_GPS_SAT' },
  { label: '2D', item: 'TWO_D_FIX' },
  { label: '3D', item: 'THREE_D_FIX_NOT_VALIDATED' },
  { label: '3D Validated', item: 'THREE_D_FIX_VALIDATED' },
];

const mapFixTypeModeList: { name: string; value: FixTypeMode }[] = [
  { name: 'Show All', value: 'SHOW_ALL' },
  { name: 'Hide Invalid', value: 'HIDE_INVALID' },
  { name: 'At Least 3D', value: 'AT_LEAST_3D' },
];

const commandStatusFilterList: FilterItemWithLabel<webEnums.CommandState>[] = [
  { label: 'Created', item: 'CREATED' },
  { label: 'Sent to Server', item: 'SENT_TO_SERVER' },
  { label: 'Sent to Device', item: 'SENT_TO_DEVICE' },
  { label: 'Failed Sending to Server', item: 'FAILED_SENDING_TO_SERVER' },
  { label: 'Failed Sending to Device', item: 'FAILED_SENDING_TO_DEVICE' },
  { label: 'Failed on Device', item: 'FAILED_ON_DEVICE' },
  { label: 'Failed Unspecified', item: 'FAILED_UNSPECIFIED' },
  { label: 'Acknowledged', item: 'ACKNOWLEDGED' },
  { label: 'Canceled', item: 'CANCELED' },
  { label: 'Failed Expired', item: 'FAILED_EXPIRED' },
];

export const filterList = {
  originFilterList: originFilterList,
  statusFilterList: statusFilterList,
  sexFilterList: sexFilterList,
  networkStatusFilterList: networkStatusFilterList,
  collarAttachedFilterList: collarAttachedFilterList,
  mortalityStatusFilterList: mortalityStatusFilterList,
  comTypeFilterList: comTypeFilterList,
  deviceTypeFilterList: [],
  mortalityTypeFilterList: mortalityTypeFilterList,
  fixTypeFilterList: fixTypeFilterList,
  mapFixTypeModeList: mapFixTypeModeList,
  vaginalImplantFilterList: vaginalImplantFilterList,
  separationTypeFilterList: separationTypeFilterList,
  commandStatusFilterList: commandStatusFilterList,
};
